<template>
  <div id="app">
    <top />
    
    <router-view></router-view>
    
    <bottom />
  </div>
</template>

<script>

import top from './components/top'
import bottom from './components/bottom'

import './sass/app.min.css'

export default {
  name: 'App',
  components: {
    top,
    bottom
  },
  data(){
    return {
      
    }
  },
  methods:{

  },
  mounted(){

  }
}
</script>

